import { Injector, Provider } from "@angular/core";
import { PortalProductStrategy } from "./strategies/portal-product-strategy";
import { EnvironmentStageService, ProductKey } from "gast-common-ng2";
import { SinglePortalProductStrategyService } from "./strategies/single-portal-product-strategy.service";
import {
  PORTAL_DEFAULT_PRODUCT_TOKEN,
  PORTAL_PRODUCT_SERVICE_TOKEN,
  PORTAL_PRODUCT_SHOW_QUERY_PARAM_TOKEN,
} from "../../constants";
import { OrganizationBasedProductStrategyService } from "./strategies/organization-based-product-strategy.service";
import { ParticipantsBasedProductStrategyService } from "./strategies/participants-based-product-strategy.service";
import { GastPortalProductStrategyOptions } from "../../models";
import { AllPossibleProductStrategyService } from "./strategies/all-possible-product-strategy.service";

export function providePortalProductService(
  gastOptions?: GastPortalProductStrategyOptions,
  showProductParamInBrowserUrl?: boolean
): Provider[] {
  return [
    {
      provide: PORTAL_PRODUCT_SHOW_QUERY_PARAM_TOKEN,
      useValue: !!showProductParamInBrowserUrl,
    },
    SinglePortalProductStrategyService,
    AllPossibleProductStrategyService,
    OrganizationBasedProductStrategyService,
    ParticipantsBasedProductStrategyService,
    {
      provide: PORTAL_DEFAULT_PRODUCT_TOKEN,
      deps: [EnvironmentStageService],
      useFactory: (stageService: EnvironmentStageService): ProductKey => {
        if (stageService.isDTZ()) {
          return "DTZ";
        } else if (stageService.isINL()) {
          return "INL";
        } else if (stageService.isGAST()) {
          if (!gastOptions) {
            throw new Error("GAST environment state detected. Provide gast options for DEFAULT_PORTAL_PRODUCT_TOKEN");
          }
          return gastOptions.defaultProduct;
        } else {
          throw new Error("PortalProductService could not be provided for unknown environment stage");
        }
      },
    },
    {
      provide: PORTAL_PRODUCT_SERVICE_TOKEN,
      deps: [EnvironmentStageService, Injector],
      useFactory: (stageService: EnvironmentStageService, injector: Injector): PortalProductStrategy => {
        if (stageService.isDTZ() || stageService.isINL()) {
          return injector.get(SinglePortalProductStrategyService);
        } else if (stageService.isGAST()) {
          if (!gastOptions) {
            throw new Error("GAST environment state detected. Provide gast options for PORTAL_PRODUCT_SERVICE_TOKEN");
          }
          if (gastOptions.mode === "SINGLE_PRODUCT") {
            return injector.get(SinglePortalProductStrategyService);
          } else {
            return injector.get(gastOptions.strategy);
          }
        } else {
          throw new Error("PortalProductService could not be provided for unknown environment stage");
        }
      },
    },
  ];
}
